export default "__VITE_ASSET__DB7GkW2k__"